import { i18n as UIKIT_RESOURCES } from "@credit-acceptance/uikit";
import { use } from "i18next";
import { initReactI18next } from "react-i18next";

import package_ from "../package.json" with { type: "json" };
import TRANSLATIONS_EN from "./languages/en.json";

// English-only for now (mirrors proof-portal-ui/consumer-portal). uikit's own
// bundle is registered under the "uikit" namespace because the form controls
// translate their own chrome — without it the DatePicker's calendar button
// announces the raw key "datepicker.select.date" to screen readers.
const resources = {
  en: {
    translation: {
      ...TRANSLATIONS_EN,
    },
    ...UIKIT_RESOURCES,
  },
};

const i18n = use(initReactI18next); // passes i18n down to react-i18next

// init() resolves synchronously here (inline resources, no backend), so the
// instance is usable immediately. Floating promise is intentional.
void i18n.init({
  resources,
  ns: ["translation", "uikit"],
  defaultNS: "translation",
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // react already safes from xss
    defaultVariables: { packageName: package_.name },
  },
});

export default i18n;
